"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadCircleIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../createIconComponent"));
var UploadCircle = function UploadCircle(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.88 0a11.88 11.88 0 1011.88 11.88A11.88 11.88 0 0011.88 0zM8.5 7.34l2.94-3.52a.58.58 0 01.88 0l2.94 3.51a.63.63 0 01.09.66.57.57 0 01-.53.36H13.2a.15.15 0 00-.15.15v5.73a1.18 1.18 0 11-2.35 0V8.5a.15.15 0 00-.15-.15H8.94A.57.57 0 018.41 8a.61.61 0 01.09-.66zm10.58 8.28a2.47 2.47 0 01-2.42 2.52H7.1a2.47 2.47 0 01-2.42-2.52v-1.17a.76.76 0 01.32-.68.72.72 0 01.75 0 .76.76 0 01.36.68v1.17a1 1 0 00.95 1h9.56a1 1 0 00.95-1v-1.17a.76.76 0 01.36-.68.72.72 0 01.75 0 .76.76 0 01.36.68z"
  }));
};
UploadCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
const UploadCircleIcon = exports.UploadCircleIcon = (0, _createIconComponent.default)(UploadCircle, 'UploadCircle');